import component from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/lni-janitorial-job-plan.component.vue';
import module from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/lni-janitorial-job-plan.module.js';

export default {
    component,
    module,
};